module.exports = __webpack_public_path__ + "img/14.c64e3fae.png";